import { GroupBy } from 'containers/CarnetsDeNotes/CarnetDetails/types';
import { CarnetDeNotesPdfSettings } from 'containers/CarnetsDeNotes/types/carnetsDeNotes';

interface Props {
  lng: string;
  settings: CarnetDeNotesPdfSettings;
  groupBy: GroupBy;
  displayGraphs: boolean;
  displayMeans: boolean;
  displayDomaines: boolean;
  displayCompetences: boolean;
  filterByNotes: number[];
  logoPath?: string;
}

export function buildCdnEleveParams(props: Props) {
  const {
    lng,
    settings,
    groupBy,
    displayGraphs,
    displayCompetences,
    displayMeans,
    displayDomaines,
    filterByNotes,
    logoPath,
  } = props;
  const params = new URLSearchParams({
    lng,
    groupBy,
    landscape: (settings.landscape || false).toString(),
    size: (settings.size || 14).toString(),
    bgColor: settings.bgColor || 'white',
    marginTop: (settings.marginTop ?? 6).toString(),
    marginBottom: (settings.marginBottom ?? 6).toString(),
    marginLeft: (settings.marginLeft ?? 6).toString(),
    marginRight: (settings.marginRight ?? 6).toString(),
    displayGlobalMean: (settings.displayGlobalMean || false).toString(),
    displaySchoolLogo: (settings.displaySchoolLogo || false).toString(),
    displayGraphs: displayGraphs.toString(),
    displayMeans: displayMeans.toString(),
    displayDomaines: displayDomaines.toString(),
    displayCompetences: displayCompetences.toString(),
    logoPath: logoPath || '',
  });
  if (filterByNotes.length > 0) {
    params.set('filterByNotes', filterByNotes.map(f => f.toString()).join(','));
  }

  if (settings.font) {
    params.set('font', settings.font);
  }

  return params;
}
